module.exports = ".equipment-selector-width {\n  width: 300px; }\n"